import { render, staticRenderFns } from "./pim.vue?vue&type=template&id=bd52170a&scoped=true&"
import script from "./pim.vue?vue&type=script&lang=js&"
export * from "./pim.vue?vue&type=script&lang=js&"
import style0 from "./pim.vue?vue&type=style&index=0&id=bd52170a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd52170a",
  null
  
)

export default component.exports